import type { Immutable } from 'immer';
import { RRImportMode, type RacemapEvent } from '../../types/events';
import { isEmptyString } from '../utils';
import { isValidRREventId } from '../validation';

export const getRaceResultImportUrl = (
  config: Immutable<RacemapEvent['integrations']['raceresult']>,
): URL | null => {
  const eventId = config.eventId;
  const starterListUrl = config.starterListUrl;
  const mode = config.importMode;

  if (mode === RRImportMode.EVENT_ID) {
    if (isEmptyString(eventId)) return null;
    if (!isValidRREventId(eventId)) throw new Error('Invalid RACE RESULT Event ID!');
    const intId = Number.parseInt(eventId, 10);

    return new URL(`https://api.raceresult.com/${intId}/RACEMAP_89G1FZBN0RZAOPZ08L77WHAJSR06K2NZ`);
  }
  if (isEmptyString(starterListUrl)) return null;
  try {
    return new URL(starterListUrl);
  } catch (err) {
    if (err instanceof Error) {
      throw new Error('Invalid URL of the starter list!');
    }

    return null;
  }
};
